/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.vod.draftDefs";

export { $nsid };

/** A draft VOD with its ats:// URI and CID, for list/get responses. */
type DraftView = { $type?: "place.stream.vod.draftDefs#draftView";

  /**
   * The ats:// URI of the draft record.
   */
  "uri":string;

  /**
   * CID (sha256 of CBOR record bytes, base32) of the draft record.
   */
  "cid":string;

  /**
   * The place.stream.vod.draftVideo record body. Typed as unknown (matching commentView/livestreamView/videoView) because the @atproto/api client validator cannot validate a ref to a record-type lexicon.
   */
  "record":l.LexMap };

export type { DraftView };

/** A draft VOD with its ats:// URI and CID, for list/get responses. */
const draftView = /*#__PURE__*/ l.typedObject<DraftView>($nsid, "draftView", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string(),"cid":/*#__PURE__*/ l.string(),"record":/*#__PURE__*/ l.lexMap()}));

export { draftView };
